"use client"

import * as React from "react"
import { TrendingDown, TrendingUp } from "lucide-react"
import { Label, Pie, PieChart } from "recharts"
import { Component as DonutChart } from "../ShadDonutChart";

// import {
//     Card,
//     CardContent,
//     CardDescription,
//     CardFooter,
//     CardHeader,
//     CardTitle,
// } from "../../components/ui/Card"
// import {
//     ChartConfig,
//     ChartContainer,
//     ChartTooltip,
//     ChartTooltipContent,
// } from "../../components/ui/Chart"
// import {
//     Select,
//     SelectContent,
//     SelectItem,
//     SelectTrigger,
//     SelectValue,
//   } from "../../components/ui/Select"
import { addDays, eachWeekOfInterval, subDays } from "date-fns"
const desktopData = [
    { month: "january", desktop: 0, fill: "var(--color-january)" },
    { month: "february", desktop: 0, fill: "var(--color-february)" },
    { month: "march", desktop: 0, fill: "var(--color-march)" },
    { month: "april", desktop: 0, fill: "var(--color-april)" },
    { month: "may", desktop: 0, fill: "var(--color-may)" },
    { month: "june", desktop: 0, fill: "var(--color-june)" },
    { month: "july", desktop: 0, fill: "var(--color-july)" },
]

const chartConfig = {
    visitors: {
        label: "Visitors",
    },
    desktop: {
        label: "Desktop",
    },
    mobile: {
        label: "Mobile",
    },
    january: {
        label: "January",
        color: "hsl(var(--chart-1))",
    },
    february: {
        label: "February",
        color: "hsl(var(--chart-2))",
    },
    march: {
        label: "March",
        color: "hsl(var(--chart-3))",
    },
    april: {
        label: "April",
        color: "hsl(var(--chart-4))",
    },
    may: {
        label: "May",
        color: "hsl(var(--chart-5))",
    },
    june: {
        label: "June",
        color: "hsl(var(--chart-6))",
    },
    july: {
        label: "July",
        color: "hsl(var(--chart-7))",
    },
}

const locationHebrewName = {
    "AHAD_HA'AM": "אחד העם",
    "SAN_MARTIN": "סן מרטין",
    "ZVI": "שדרות צבי",
    "BERNSTEIN": "פרץ ברנשטיין",
    "CENTER_OF_THE_PARK": "חניוני לב הפארק",
    "SHAKH":"שחר",
    "CHEN":"חן"
}

export function NationalParkDonutChart({ data, deviceNames, donutDeviceName, setDonutDeviceName }) {
    console.log(deviceNames, data, data.length, desktopData[desktopData.length - 1].desktop, "deviceNames");

    const dateRangeSundays = eachWeekOfInterval({
        start: new Date(data[0].date),
        end: new Date(data[data.length - 1].date)
    });

    let lastSundayDate = dateRangeSundays[dateRangeSundays.length - 2];

    let lastToLastSundayDate = dateRangeSundays[dateRangeSundays.length - 3];

    let lastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length - 1], 1);

    let lastToLastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length - 2], 1);



    const result = data.reduce((acc, curr) => {
        const dateOnly = curr.date.split("T")[0]; // Extract the date part (YYYY-MM-DD)
        acc[dateOnly] = (acc[dateOnly] || 0) + curr.entering; // Sum up "entering"
        return acc;
    }, {});

    console.log(result, "resulta");



    const formattedResult = Object.entries(result).map(([date, enteringSum]) => ({
        date,
        enteringSum
    }));

    console.log(formattedResult, formattedResult.length, "result");

    formattedResult.slice(formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(lastSundayDate).getDate()), formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(addDays(lastSaturdayDate, 1)).getDate())).forEach((element, i) => {

        desktopData[i].month = new Date(element.date).toLocaleString('he-us', { day: 'numeric', month: 'short', weekday: 'short' });

        desktopData[i].desktop = element.enteringSum;

    });

    const currentWeekValue = desktopData.reduce((acc, item) => acc + item.desktop, 0);
    const lastWeekValue = formattedResult.slice(formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(lastToLastSundayDate).getDate()), formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(addDays(lastToLastSaturdayDate, 1)).getDate())).reduce((acc, item) => acc + item.enteringSum, 0);
    const weeklyDifference = currentWeekValue - lastWeekValue;
    console.log(desktopData, lastWeekValue, currentWeekValue, "desktopData");

    const id = "pie-interactive"
    const [activeMonth, setActiveMonth] = React.useState(deviceNames[0])

    const activeIndex = React.useMemo(
        () => desktopData.findIndex((item) => item.month === activeMonth),
        [activeMonth]
    )
    const months = React.useMemo(() => deviceNames.map((item) => item), [])

    return (
        <DonutChart
            weeklyDifference={weeklyDifference}
            desktopData={desktopData}
            chartConfig={chartConfig}
            locationHebrewName={locationHebrewName}
            deviceNames={deviceNames}
            setDonutDeviceName={setDonutDeviceName}
            donutDeviceName={donutDeviceName}
            currentWeekValue={currentWeekValue}
        />
        // <Card className="flex flex-col">
        //     <CardHeader className="flex items-center gap-2 space-y-0 border-b py-3 sm:flex-row">
        //         {/* <div className="grid flex-1 gap-1 text-center sm:text-left">
        //             <CardTitle>Pie Chart - Donut with Text</CardTitle>
        //             <CardDescription>January - June 2024</CardDescription>
        //         </div> */}
        //         <div className="grid flex-1 gap-1 justify-end text-center sm:text-left">
        //             <Select value={donutDeviceName} onValueChange={setDonutDeviceName}>
        //                 <SelectTrigger
        //                     className="ml-auto h-7 w-[130px] rounded-lg pl-2.5"
        //                     aria-label="Select a value"
        //                 >
        //                     <SelectValue placeholder="Select month" />
        //                 </SelectTrigger>
        //                 <SelectContent align="end" className="rounded-xl">
        //                     {deviceNames.map((key) => {
        //                         //   const config = chartConfig[key]

        //                         //   if (!config) {
        //                         //     return null
        //                         //   }

        //                         return (
        //                             <SelectItem
        //                                 key={key}
        //                                 value={key}
        //                                 className="rounded-lg [&_span]:flex"
        //                             >
        //                                 <div className="flex items-center gap-2 text-xs">
        //                                     {/* <span
        //               className="flex h-3 w-3 shrink-0 rounded-sm"
        //               style={{
        //                 backgroundColor: `var(--color-${key})`,
        //               }}
        //             /> */}
        //                                     {locationHebrewName[key]}
        //                                 </div>
        //                             </SelectItem>
        //                         )
        //                     })}
        //                 </SelectContent>
        //             </Select>
        //         </div>
        //     </CardHeader>
        //     <CardHeader className="flex items-end pb-0">
        //         <CardTitle>{locationHebrewName[donutDeviceName]}</CardTitle>
        //         <CardDescription>סה״כ רכבים שנכנסו בשבוע החולף</CardDescription>
        //     </CardHeader>
        //     <CardContent className="flex-1 pb-0">
        //         <ChartContainer
        //             config={chartConfig}
        //             className="mx-auto aspect-square max-h-[245px]"
        //         >
        //             <PieChart>
        //                 <ChartTooltip
        //                     cursor={false}
        //                     content={<ChartTooltipContent hideLabel />}
        //                 />
        //                 <Pie
        //                     data={desktopData}
        //                     dataKey="desktop"
        //                     nameKey="month"
        //                     innerRadius={60}
        //                     strokeWidth={5}
        //                 >
        //                     <Label
        //                         content={({ viewBox }) => {
        //                             if (viewBox && "cx" in viewBox && "cy" in viewBox) {
        //                                 return (
        //                                     <text
        //                                         x={viewBox.cx}
        //                                         y={viewBox.cy}
        //                                         textAnchor="middle"
        //                                         dominantBaseline="middle"
        //                                     >
        //                                         <tspan
        //                                             x={viewBox.cx}
        //                                             y={viewBox.cy}
        //                                             className="fill-foreground text-3xl font-bold"
        //                                         >
        //                                             {currentWeekValue.toLocaleString("en-US")}
        //                                         </tspan>
        //                                         <tspan
        //                                             x={viewBox.cx}
        //                                             y={(viewBox.cy || 0) + 24}
        //                                             className="fill-muted-foreground"
        //                                         >
        //                                         בשבוע החולף
        //                                         </tspan>
        //                                     </text>
        //                                 )
        //                             }
        //                         }}
        //                     />
        //                 </Pie>
        //             </PieChart>
        //         </ChartContainer>
        //     </CardContent>
        //     <CardFooter className="flex-col gap-1 text-sm">
        //         <div className="flex flex-wrap flex-row gap-1 font-medium leading-none">
        //             <div>
        //                 שחלף
        //             </div>
        //             <div>
        //                 בשבוע 
        //             </div>
        //             <div>
        //                 { weeklyDifference < 0 ? (weeklyDifference*-1).toLocaleString("en-US"):weeklyDifference.toLocaleString("en-US") }
        //             </div>
        //             <div>
        //                 של
        //             </div>
        //             <div>
        //                 { weeklyDifference < 0 ? "ירידה":"עליה" }
        //             </div>
        //             <div>
        //                 מגמת
        //             </div>
        //             <div>
        //                 { weeklyDifference < 0 ? <TrendingDown className="h-4 w-4" /> : <TrendingUp className="h-4 w-4" /> }
        //             </div>
        //         </div>
        //         <div className="leading-none text-muted-foreground">
        //             בהשוואה לשבוע שלפני השבוע שחלף
        //         </div>
        //     </CardFooter>
        // </Card>
    )
}
